var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M17,22H5V2H17V4h2V1a.945.945,0,0,0-1-1H4A.945.945,0,0,0,3,1V23a.945.945,0,0,0,1,1H18a.945.945,0,0,0,1-1V20H17Z"}}),_c('polygon',{attrs:{"points":"22 12 15 6 15 11 8 11 8 13 15 13 15 18 22 12"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }